import { IAutoMapper } from "../interfaces";

export const mapAlertNotification = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AlertNotification")
    .forMember("alertId", o => o.alertId)
    .forMember("alertType", o => o.alertType)
    .forMember("name", o => o.name)
    .forMember("message", o => o.messsage)
    .forMember("createdDate", o => o.createdDate)
    .forMember("objectType", o => o.objectType)
    .forMember("objectId", o => o.objectId)
    .forMember("loggedInUserId", o => o.loggedInUserId)
    .forMember("timeStamp", o => o.timeStamp)
    .forMember("alertURL", o => o.alertURL)
    .forMember("recordCount", o => o.recordCount)
    .forMember("supplemental", o => o.supplemental);
};

